import { screenModule } from '@/store/screen/module'

const getBreakpoint = () => {
    return screenModule.state.breakpoint
}

export default {
    getBreakpoint,
}
